// The generated SDKs throw ApiException, which carries the status both on `code` and inside the
// message as "HTTP-Code: <status>". Portal had two answers to "what status was this?" —
// `use404Redirect` read `.code`, `contexts/QueryClient` string-matches the message — so this is
// the one place that knows about both shapes.
const HTTP_CODE_MESSAGE_PATTERN = /HTTP-Code:\s*(\d{3})/;

type MaybeApiError = Readonly<{ code?: unknown; message?: unknown }>;

export const getHttpStatusCode = (error: unknown): number | null => {
  if (typeof error !== 'object' || error === null) {
    return null;
  }

  const { code, message } = error as MaybeApiError;
  if (typeof code === 'number') {
    return code;
  }
  if (typeof message !== 'string') {
    return null;
  }

  const match = HTTP_CODE_MESSAGE_PATTERN.exec(message);
  return match === null ? null : Number(match[1]);
};

export const isHttpStatus = (error: unknown, status: number): boolean => {
  return getHttpStatusCode(error) === status;
};
